export const ADD_REGISTRATION = 'ADD_REGISTRATION';